class EmailViewController {

    constructor($sce) {
        this.$sce = $sce;
    }

    loadContent () {
        return this.$sce.trustAsHtml(this.emailContent);
    }
}

EmailViewController.$inject = ['$sce'];

export default EmailViewController;



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/order/controllers/email.view.controller.js